'use strict'

angular.module('rmEPG')

    .config(['$stateProvider', function ($stateProvider) {

        function createBroadcastFormWindowIfNotExists (bladesManager) {
            return new Promise(resolve => {
                if (!bladesManager.all(1).some(el => el.viewName === 'broadcast')) {
                    bladesManager.insertFloating({
                        viewName: 'broadcast',
                        size: 'half-floating',
                        extraClasses: 'half epg-card'
                    }) // @todo half floating blade hack
                        .then(() => resolve())
                } else {
                    resolve()
                }
            })
        }

        let programCreateStateCreate = {
            url: '/new-program',
            views: {
                'program-detail@': {
                    templateUrl: '/partial/app.partials.program.detail',
                    controller: 'ProgramFormCtrl',
                    controllerAs: 'programCtrl'
                }
            },
            params: {
                fromOtherSource: true,
                title: null
            },
            onEnter: ['bladesManager', function (bladesManager) {
                createBroadcastFormWindowIfNotExists(bladesManager).then(() => {
                    var loadedViews = bladesManager.all(1)
                    var found = loadedViews.some(function (el) {
                        return el.viewName === 'program-detail'
                    })

                    if (!found) {
                        bladesManager.insertRight({
                            viewName: 'program-detail',
                            size: 'half-floating',
                            extraClasses: 'half'
                        }, 1) // @todo half floating blade hack
                    }
                })
            }],
            onExit: ['$state', '$stateParams', 'Contact', 'bladesManager', function ($state, $stateParams, Contact, bladesManager) {
                //ugly!
                if (!$state.includes('broadcast')) {
                    bladesManager.removeRight('program-detail', 1)
                }
            }],
        }
        let programCreateStateUpdate = angular.copy(programCreateStateCreate)

        let presenterCreateStateCreate = {
            url: '/new-presenter',
            views: {
                'presenter-detail@': {
                    templateUrl: '/partial/app.partials.presenter.detail',
                    controller: 'PresenterFormCtrl',
                    controllerAs: 'presenterCtrl',
                },
            },
            params: {
                fromOtherSource: true,
                name: null,
            },
            onEnter: ['bladesManager', function (bladesManager) {
                createBroadcastFormWindowIfNotExists(bladesManager).then(() => {
                    var loadedViews = bladesManager.all(1)
                    var found = loadedViews.some(function (el) {
                        return el.viewName === 'presenter-detail'
                    })

                    if (!found) {
                        bladesManager.insertRight({
                            viewName: 'presenter-detail',
                            size: 'half-floating',
                            extraClasses: 'half'
                        }, 1) // @todo half floating blade hack
                    }
                })
            }],
            onExit: ['$state', '$stateParams', 'Contact', 'bladesManager', function ($state, $stateParams, Contact, bladesManager) {
                //ugly!
                if (!$state.includes('broadcast')) {
                    bladesManager.removeRight('presenter-detail', 1)
                }
            }]
        }
        let presenterCreateStateUpdate = angular.copy(presenterCreateStateCreate)
        //Broadcasts
        $stateProvider
            .state('epg', {

                url: '/epg?date',
                views: {
                    'epg': {
                        templateUrl: '/partial/app.partials.epg.schedule_week',
                        controller: 'BroadcastScheduleCtrl',
                        controllerAs: 'schedule'
                    }
                },
                reloadOnSearch: false,
                resolve: {
                    zoomFactor: ['$http', function ($http) {
                        return $http.get('/usersettings').then((req) => {
                            return req.data.zoomFactor || 100
                        })
                    }]
                },
                onEnter: ['bladesManager', function (bladesManager) {

                    bladesManager.clearAll()
                    bladesManager.insert({ viewName: 'epg', size: 'full' })
                }]
            })
            .state('epg.create', {
                url: '/broadcast/create?:start&:end',
                views: {
                    'broadcast@': {
                        templateUrl: '/partial/app.partials.broadcast.detail',
                        controller: 'EpgBroadcastFormCtrl',
                        controllerAs: 'bcCtrl',
                    },
                },
                reloadOnSearch: false,
                onEnter: ['bladesManager', function (bladesManager) {
                    createBroadcastFormWindowIfNotExists(bladesManager)
                }],
                onExit: ['bladesManager', function (bladesManager) {
                    if (bladesManager.getFloatingState()) {
                        bladesManager.removeAllFloating()
                    }
                }]
            })
            .state('epg.update', {
                url: '/broadcast/update/:broadcastId',
                views: {
                    'broadcast@': {
                        templateUrl: '/partial/app.partials.broadcast.detail',
                        controller: 'EpgBroadcastFormCtrl',
                        controllerAs: 'bcCtrl',
                    },
                },
                reloadOnSearch: false,
                onEnter: ['bladesManager', function (bladesManager) {
                    createBroadcastFormWindowIfNotExists(bladesManager)
                }],
                onExit: ['bladesManager', '$stateParams', function (bladesManager, $stateParams) {
                    if (bladesManager.getFloatingState() && !$stateParams.change) {
                        bladesManager.removeAllFloating()
                    }
                }]
            })
            .state('epg.create.program', programCreateStateCreate)
            .state('epg.update.program', programCreateStateUpdate)

            .state('epg.create.program.presenter', angular.copy(presenterCreateStateCreate))
            .state('epg.update.program.presenter', angular.copy(presenterCreateStateUpdate))

            .state('epg.create.presenter', presenterCreateStateCreate)
            .state('epg.update.presenter', presenterCreateStateUpdate)

    }])
